import { Scene } from 'three';
import { IMode } from '../../zustand';
import { IButton, IComponentsById, IComponentType, IImage, ISpatialComponentUnion, IText, ITrackingTypes, ITuple3, IVideo } from '@r3f-component-data-structure';

export const getAdjustedPosition = (arMode: IMode | undefined, screenRelative: boolean, position: ITuple3): ITuple3 => {
	const p = [...position] as ITuple3;

	if (arMode !== IMode.nonar && !screenRelative) {
		//console.log('halve position');
		return [p[0] / 2, p[1] / 2, p[2] / 2];
	}
	return p;
};

export const getAdjustedScale = (arMode: IMode | undefined, screenRelative: boolean, scale: ITuple3): ITuple3 => {
	// if in non ar mode and not screen relative entity or screen relative entity adjust size
	if ((arMode === IMode.nonar && !screenRelative) || screenRelative) {
		return [scale[0] * 2, scale[1] * 2, scale[2] * 2];
	}
	return scale as ITuple3;
};

export const getAdjustedFontSize = (arMode: IMode | undefined, screenRelative: boolean, entity: IButton | IText): number => {
	if ((arMode === IMode.nonar && !screenRelative) || screenRelative) {
		return entity.fontSize;
	}
	return entity.fontSize / 2;
};

export const getAdjustedBorderWidth = (arMode: IMode | undefined, screenRelative: boolean, entity: IButton | IVideo | IImage): number => {
	if ((arMode === IMode.nonar && !screenRelative) || screenRelative) {
		return entity.borderWidth ?? 0;
	}
	return (entity.borderWidth ?? 0) / 2;
};

export const resetEntityTransforms = (entityId: string, scene: Scene) => {
	const outerThreeGroup = scene.getObjectByName(`transformGroup-${entityId}`);
	const innerThreeGroup = scene.getObjectByName(`transformGroup-inner_${entityId}`);
	
	outerThreeGroup?.rotation.set(0, 0, 0)
	outerThreeGroup?.scale.set(1, 1, 1);

	innerThreeGroup?.rotation.set(0, 0, 0)
	innerThreeGroup?.position.set(0, 0, 0);
	innerThreeGroup?.scale.set(1, 1, 1);
}

export const hasTapAction = (component: ISpatialComponentUnion) => {
	return !!component.actions?.onTap?.length;
}

export const getAllUsedImageTrackerIds = (componentsById: IComponentsById | null) => {
	const usedIds: string[] = [];
	if (!componentsById) return usedIds;
	for (const id in componentsById) {
		const component = componentsById[id];
		if (component.type !== IComponentType.Scene || component.trackingType !== ITrackingTypes.image) continue;
		const {trackingImageId} = component;
		if (!usedIds.includes(trackingImageId)) usedIds.push(trackingImageId);
	}
	return usedIds;
}